import gql from 'graphql-tag';

export default gql`
  query getPaymentPlans {
    getPaymentPlans(active: true, limit: 500) {
      id
      active
      amount
      currency
      interval
      nickname
      metadata
    }
  }
`;
